import MapProvider from "./MapFilterContext";
import StatusProvider from "./StatusContext";
import {
  QueryClient,
  QueryClientProvider,
  useQuery,
} from "@tanstack/react-query";

const queryClient = new QueryClient();

export default function Provider({ children }) {
  return (
    <StatusProvider>
      <QueryClientProvider client={queryClient}>
        {children}
      </QueryClientProvider>
    </StatusProvider>
  );
}
